import * as page from '../commonPages/shop';
// import * as parallelPage from '../commonPages/newShop'
import pageDisable from '../helpers/pageDisableHelper';

export async function getServerSideProps({ req, res, query }) {
  return page.getServerSideProps({ req, res, query });
}

export default pageDisable(page.Shop);
